import PropTypes from 'prop-types';
import { LOAD_PERMISSIONS } from "../../store/permissions/types";
import React, { useState, useEffect } from "react";
import { Row, Col, CardBody, Card, Container, Label, Form, FormFeedback, Input } from "reactstrap";

// Redux
import { connect, useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
import logoSm from "../../assets/images/logo-sm.png";
import login from "../../assets/images/login.png";

const Login = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [error, setError] = useState(false);

  const permissionMap = useSelector(
    state => state.permissions?.permissions
  );

  useEffect(() => {
    if (loginSuccess && permissionMap && Object.keys(permissionMap).length > 0) {
      navigate("/dashboard", { replace: true });
    }
  }, [loginSuccess, permissionMap]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      try {
        const authResponse = await fetch("https://api.kunalsdrumclass.com/api/DI");

        if (!authResponse.ok) throw new Error("Unable to fetch token");

        const tokenString = await authResponse.text();
        const token = JSON.parse(tokenString);
        localStorage.setItem("authToken", token);
        const loginResponse = await fetch("https://api.kunalsdrumclass.com/api/Login", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            emailAddress: values.email,
            password: values.password
          })
        });

        if (!loginResponse.ok) {
          setError("Invalid Username or Password!");
          return;
        }

        const result = await loginResponse.json();
        const userData = result?.recordsets?.[0]?.[0];
        const usersData = result?.recordsets?.[0] || [];
        if (result?.recordsets?.[0]?.[0]?.Status === 0) {
          setError("Please check your credencials!");
          return; 
        } else if (result?.recordsets?.[0]?.[0]?.Status === -1) {
          setError("Not allowed to login. Please contact admin.");
          return; 
        } else if (result?.recordsets?.[0]?.[0]?.Status === -2) {
          setError("Student is in-active. Please contact admin.");
          return; 
        } else if (result?.recordsets?.[0]?.[0]?.Status === -3) {
          setError("Student is pending for approval. Please contact admin.");
          return; 
        } else if (result?.recordsets?.[0]?.[0]?.Status === -4) {
          setError("Student is not approved. Please contact admin.");
          return; 
        } else if (result?.recordsets?.[0]?.[0]?.Status === 1) {
          localStorage.setItem("authUser", JSON.stringify(userData));
          localStorage.setItem("authUsers", JSON.stringify(usersData));
          dispatch({ type: LOAD_PERMISSIONS });
          setLoginSuccess(true);
        }
      } catch (err) {
        console.error(err);
        setError("Something went wrong! Check server.");
      }
    }
  });

  document.title = "Login | KDC - Kunal's Drum Class";
  return (
    <React.Fragment>
      <div className="account-pages login-page">
        <Container>
          <Row className="justify-content-center">

            {/* LEFT SIDE IMAGE */}
            <Col md={4} className="d-none d-md-flex p-0">
              <div className="login-image-wrapper">
                <img
                  src={login}
                  alt="logo"
                />
              </div>
            </Col>

            {/* RIGHT SIDE LOGIN */}
            <Col md={6} lg={5} xl={4} className="p-0">
              <Card className="login-side overflow-hidden h-100">
                <div className="">
                  <div className="text-primary text-center p-4">
                    <h3 className="text-white">
                      Welcome Back !
                    </h3>
                    <p className="text-white">
                      Sign in to continue to KDC.
                    </p>

                    <Link to="/" className="logo logo-admin">
                      <img src={logoSm} height="40" alt="logo" />
                    </Link>
                  </div>
                </div>

                <CardBody className="p-4">
                  <div className="p-3">
                    <Form className="mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                      action="#">

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="username">Email*</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Email"
                          type="email"
                          id="username"
                          onChange={(e) => {
                            validation.setFieldValue("email", e.target.value.toLowerCase());
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="userpassword">Password*</Label>
                        <div className="input-group">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={showPassword ? "text" : "password"}
                            className="form-control"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />

                          <span
                            className="input-group-text"
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <i className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                          </span>

                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                          ) : null}
                        </div>
                      </div>
                      {error && <p className="text-danger">{error}</p>}
                      <div className="mb-3 row">
                        <div>
                          <button className="btn btn-primary w-100 waves-effect waves-light" type="submit">Log In</button>
                        </div>
                      </div>

                      <div className="mt-2 mb-0 row">
                        <div className="col-12 text-center mt-4">
                          <Link to="/forgot-password" style={{ color: "#fff" }}>Forgot password?</Link>
                        </div>
                      </div>

                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>

          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};



export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object
};